export default {
  path: '/wecode/migrate-to-welink',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'migrate-to-welink',
  component: () => import('./index')
};
